'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Removes all trailing slashes at end of string
 * @param {string} url 
 */
var removeTrailingSlash = exports.removeTrailingSlash = function removeTrailingSlash(url) {
  if (!url) {
    return url;
  }

  return url.replace(/\/+$/, "");
};

/**
 * Sanitizes url to return domain. 
 * Removes http:// and https:// and trailing slashes '/'
 * @param {string} url 
 */
var sanitizeUrl = exports.sanitizeUrl = function sanitizeUrl(url) {
  if (!url) {
    return url;
  }

  return removeTrailingSlash(url.replace('https://', '').replace('http://', ''));
};

var getDomainFromUrl = exports.getDomainFromUrl = function getDomainFromUrl(uri) {
  var includeProtocol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!uri) {
    return uri;
  }

  var hostnamePattern = /(.+:\/\/)?([^\/]+)(\/.*)*/i;
  var results = hostnamePattern.exec(uri);
  var hostname = includeProtocol ? results[1] + results[2] : results[2];
  return hostname;
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/UrlService.js
// module id = 819
// module chunks = 10